import axios from 'axios';
import { useAuthStore } from '../store/authStore'; // Adjust path to your zustand store

const axiosInstance = axios.create({ baseURL: '/api' });

// Request Interceptor: Attach the token to every request
axiosInstance.interceptors.request.use((config) => {
    const token = useAuthStore.getState().token;
    if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
}, (error) => Promise.reject(error));

// Response Interceptor: Catch 401 Unauthorized errors (Session Expired)
axiosInstance.interceptors.response.use(
    (response) => {
        // Any status code that lies within the range of 2xx causes this function to trigger
        return response;
    }, 
    (error) => {
        // Any status codes that fall outside the range of 2xx cause this function to trigger
        if (error.response && error.response.status === 401) {
            // 1. Clear the authentication state (token and user info)
            useAuthStore.getState().logout();
            
            // 2. Redirect to the login page
            window.location.href = '/login'; 
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;